import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=1058dc82&"
import script from "./editAnnouncement.vue?vue&type=script&lang=js&"
export * from "./editAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./editAnnouncement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports